import { exhaustiveCheck } from '@direct-frontend/stdlib';
import { OperatorType } from '../types/Operator';
import { i18n } from './getOperatorTitle.i18n';

export function getOperatorTitle(operatorType: OperatorType): string {
    switch (operatorType) {
        case OperatorType.Lt:
            return '<';
        case OperatorType.Gt:
            return '>';
        case OperatorType.Eq:
            return i18n('равно');
        case OperatorType.Ne:
            return i18n('не равно');
        case OperatorType.Like:
            return i18n('содержит');
        case OperatorType.NotLike:
            return i18n('не содержит');
        case OperatorType.Le:
            return '<=';
        case OperatorType.Ge:
            return '>=';
        default:
            exhaustiveCheck(operatorType, 'Unknown operator');
    }
}
